import api from './api';
import type { QuotationPayload } from '../types';

export const quotationService = {
  submitQuotation: async (payload: QuotationPayload): Promise<void> => {
    await api.post('quotations', { json: payload });
  },
};
